import { FiFileText, FiDollarSign } from 'react-icons/fi';
import { StatCard, StatCardGrid } from '../../components/common';
import { SUMMARY } from '../../constants/labels';
import { fmtCurrency } from '../../utils/formatNumber';
import { EXPENSES_LABEL } from './paymentsConfig';

export default function PaymentsSummaryCards({ vouchers }) {
  const totalAmount = vouchers.reduce((s, v) => s + parseFloat(v.amount || 0), 0);

  return (
    <StatCardGrid cols={2}>
      <StatCard
        icon={<FiDollarSign size={18} />}
        iconBg="rgba(239,68,68,0.12)"
        iconColor="#ef4444"
        label={SUMMARY.totalPaid}
        value={fmtCurrency(totalAmount)}
        valueColor="red"
      />
      <StatCard
        icon={<FiFileText size={18} />}
        iconBg="rgba(99,102,241,0.12)"
        iconColor="#6366f1"
        label={`Total ${EXPENSES_LABEL.plural}`}
        value={String(vouchers.length)}
      />
    </StatCardGrid>
  );
}
